import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AudienceActivityLoadFulfilledAction } from '../../domains/audienceActivity/actions.types';
import type { UserAudienceCountsAction } from '../../domains/leadersManagement/loadUserAudienceCountsActions.types';

import type { UserAudienceCounts } from './types';

const initialState: UserAudienceCounts = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type UserAudienceCountsLoadAction = UserAudienceCountsAction | AudienceActivityLoadFulfilledAction;

const reducer: Reducer<UserAudienceCounts, UserAudienceCountsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_AUDIENCE_COUNTS.LOAD_PENDING':
      return moveToPending(state, [action.payload.userId]);
    case 'USER_AUDIENCE_COUNTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities);
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.leaderAudience);
    case 'USER_AUDIENCE_COUNTS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.userId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
